import { Action } from 'redux';
// For some reason typescript didn't allow the correct import:
// import { dispatchableFetch } from '@xingternal/hops-redux';
// so we had to resort to this:
import dispatchableFetch from '@xingternal/hops-redux/dispatchableFetch';
import type {} from 'redux-thunk/extend-redux'; //eslint-disable-line
import { ThunkAction } from 'redux-thunk';
import { fetchJson } from '@xingternal/hops-fetch';

export const dispatchableGet = <R, S = unknown, A = unknown>({
  url,
  onSuccess,
  onError,
  onLoading,
}): ThunkAction<R, S, { fetchJson: fetchJson }, Action<A>> => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return dispatchableFetch<R>({
    url: url,
    onSuccess,
    onStart: onLoading,
    onError,
  });
};

export const dispatchablePost = <R, P, S = unknown, A = unknown>({
  url,
  onSuccess,
  onError,
  onLoading,
  params,
}): ThunkAction<R, S, { fetchJson: fetchJson }, Action<A>> => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return dispatchableFetch<R>({
    url: url,
    onSuccess,
    onStart: onLoading,
    onError,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
};

export const dispatchablePut = <R, P, S = unknown, A = unknown>({
  url,
  onSuccess,
  onError,
  onLoading,
  params,
}): ThunkAction<R, S, { fetchJson: fetchJson }, Action<A>> => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return dispatchableFetch<R>({
    url: url,
    onSuccess,
    onStart: onLoading,
    onError,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
};
